import React, { useEffect, useRef, useState } from "react";
import { AirbudsYearlyHeader } from "./component/storyHeader";
import { useNavigate } from "react-router";
import { motion, animate } from "motion/react";
import StoryProgressBar from "./component/pagination";
import { StoryOverlay } from "./compat/compat";

export function useStateAndRef(initial) {
  const [value, setValue] = useState(initial);
  const valueRef = useRef(value);
  valueRef.current = value;
  return [value, setValue, valueRef];
}

export const Intro = ({ data }) => {
  const [step, setStep, refStep] = useStateAndRef(0);
  const navigate = useNavigate();

  const previous = () => {
    setStep(Math.max(step - 1, 0));
  };

  const next = () => {
    if (step == 3) {
      navigate("/menu");
    } else {
      setStep(Math.min(step + 1, 8));
    }
  };

  const renderState = (state) => {
    switch (state) {
      case 0:
        return (
          <motion.div
            key="step-1"
            className="app-stats-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 1, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.5,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <h3 className="title">Welcome to your</h3>
            <img
              src={require("./assets/img/chrome2024.png")}
              alt="airbuds yearly recap"
              class="full-centered-img"
            />
            <h1 className="title subtile-stats">2024 airbuds recap</h1>
          </motion.div>
        );
      case 1:
        return (
          <motion.div
            key="step-1"
            className="app-thanks-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <motion.p
              className="type-text"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.0,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              we’re doing things a little differently this year…
            </motion.p>
          </motion.div>
        );
      case 2:
        return (
          <motion.div
            key="step-2"
            className="app-thanks-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <motion.h3
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.0,
                ease: [0, 0.71, 0.2, 1.01],
              }}
              className="headline-light"
            >
              Meet your Airbuds Advent Calendar.
            </motion.h3>

            <motion.p
              className="type-text"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              Open a new stat each day and your full recap will be available the
              last day– December 20th.
            </motion.p>
          </motion.div>
        );

      case 3:
        return (
          <motion.div
            key="step-4"
            className="app-thanks-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <motion.h1
              className="big-headline"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.0,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              Let’s begin…
            </motion.h1>
          </motion.div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <div className={"app-stats-container thanks-gradient-background "}>
      {renderState(step)}
      <StoryOverlay prev={previous} next={next} />
      <AirbudsYearlyHeader
        closeAction={() => {
          navigate("/menu");
        }}
      />
      <StoryProgressBar
        className="story-bar"
        totalPages={4}
        currentPage={step}
        duration={0}
      />
    </div>
  );
};
